import fetcher from '../../fetch/fetcher';

export const coinGeckoEndpoints = {
    priceChart: (slug: string, vsCurrency: string, unixFrom: number, unixTo: number): string =>
        `https://pro-api.coingecko.com/api/v3/coins/${slug}/market_chart/range?vs_currency=${vsCurrency}&from=${unixFrom}&to=${unixTo}&x_cg_pro_api_key=${process.env.COINGECKO_API_KEY}`,
};

interface PriceChartResponse {
    prices: any[];
    market_caps: any[];
    total_volumes: any[];
}

export const fetchPriceChart = async (
    slug: string,
    vsCurrency: string,
    unixFrom: number,
    unixTo: number
): Promise<PriceChartResponse[]> => {
    const response = await fetcher(coinGeckoEndpoints.priceChart(slug, vsCurrency, unixFrom, unixTo), {
        credentials: 'omit',
    });
    return response;
};
